import { className as cx } from "@/helpers/utility/class_name";
import style from "./content_card.module.css";

export default function ContentCard({
  header = "",
  bgColor = "",
  parentStyle = "",
  cardContainer = false,
  withOnlyOneColumn = false,
  newStyleContentCard = false,
  ...props
}) {
  const padding = header != "" ? "p-3" : "p-1";
  const gradient = "bg-gradient-to-b from-[#fff] to-[#E6E6E6]";
  const bg = (bgColor != "" || newStyleContentCard) ? bgColor : gradient;

  return (
    <div className={cx(style.content_card, parentStyle,
                       newStyleContentCard ? style.flat : '',
                       cardContainer ? style.content_card_container : '')}>
      {!cardContainer && (
        <h4 className={cx(style.card_header, padding, header == "noheader" ? "hidden" : "")}>{header}</h4>
      )}
      <div className={cx(style.card_body, bg, withOnlyOneColumn ? style.standalone : '')}>
        {props.children}
      </div>
    </div>
  );
}
